import React, { useState } from 'react';
import { sendSubscription } from '../services/emailService';
import '../styles/SubscriptionSection.css';

const SubscriptionSection = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('idle'); // 'idle', 'success', 'error'
  const [message, setMessage] = useState('');
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email.trim()) {
      setSubmitStatus('error');
      setMessage('Vui lòng nhập địa chỉ email');
      return;
    }

    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setSubmitStatus('error');
      setMessage('Email không hợp lệ');
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus('idle');
    setMessage('');

    try {
      console.log('📧 Submitting subscription for:', email);
      
      const result = await sendSubscription(email);
      
      if (result.success) {
        setSubmitStatus('success');
        setMessage(result.message);
        setEmail(''); // Clear form on success
        
        // Clear success message after 5 seconds
        setTimeout(() => {
          setSubmitStatus('idle');
          setMessage('');
        }, 5000);
      } else {
        throw new Error(result.message || 'Có lỗi xảy ra');
      }
    } catch (error) {
      console.error('Subscription error:', error);
      setSubmitStatus('error');
      setMessage(error.message || 'Có lỗi xảy ra. Vui lòng thử lại sau.');
      
      // Clear error message after 8 seconds
      setTimeout(() => {
        setSubmitStatus('idle');
        setMessage('');
      }, 8000);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="subscription-section">
      <div className="container">
        <div className="subscription-wrapper">
          <div className="subscription-content">
            <div className="subscription-icon">
            </div>
            <h2>Đăng ký nhận thông tin mới nhất</h2>
            <p>Nhận các thông tin về sản phẩm, dịch vụ, và khuyến mãi mới nhất từ Phúc An Solutions</p>
            
            <form className="subscription-form" onSubmit={handleSubmit}>
              <div className="input-group">
                <input 
                  type="email" 
                  placeholder="Nhập địa chỉ email của bạn..." 
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={isSubmitting}
                  required 
                />
                <button 
                  type="submit" 
                  disabled={isSubmitting || !email.trim()}
                  className={isSubmitting ? 'submitting' : ''}
                >
                  {isSubmitting ? (
                    <>
                      <span>ĐANG GỬI...</span>
                      <span className="spinner">⏳</span>
                    </>
                  ) : (
                    <>
                      <span>ĐĂNG KÝ NGAY</span>
                      <span className="arrow">→</span>
                    </>
                  )}
                </button>
              </div>
              
              {/* Status Messages */}
              {message && (
                <div className={`subscription-message ${submitStatus}`}>
                  {submitStatus === 'success' && <span className="icon">✅</span>}
                  {submitStatus === 'error' && <span className="icon">❌</span>}
                  <span className="text">{message}</span>
                </div>
              )}
            </form>
            
            <div className="subscription-note">
              <small>* Chúng tôi cam kết bảo mật thông tin cá nhân của bạn</small>
            </div>
          </div>
          
          <div className="subscription-features">
            <div className="feature-item">
              <span className="feature-icon">🔔</span>
              <span>Thông báo sản phẩm mới</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">💡</span>
              <span>Giải pháp công nghệ</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">🎯</span>
              <span>Ưu đãi đặc biệt</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SubscriptionSection; 